import { FC } from "react";

import { PopupImportImageUrlFieldCell } from "./PopupImportImageUrlFieldCell";

type Props = {
  base: string;
  slot: number;
};

/** 画像-N column: image URL field + remote thumbnail (import uses URLs only; no file upload). */
export const PopupImportImageSlotCell: FC<Props> = ({ base, slot }) => {
  const urlName = `${base}.popupImages.${slot}.imageUrl`;
  return <PopupImportImageUrlFieldCell name={urlName} />;
};
